import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchPostsByCategory } from '../api'
import PostListTemplate from '../components/Blog/templates/PostListTemplate'

function SingleCategoryPage() {

    const{id} = useParams()

    const [posts, setPosts] = useState([])
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(100)

    useEffect(() => {

        async function getPostsByCategory() {
            const data = await fetchPostsByCategory(page, perPage, id)
            if (data?.length > 0) {
                setPosts(data)
            }
        }
        getPostsByCategory();

    }, [id])

    return (
        <div className="container my-4">
            <div className="row">
                {posts?.map((post, index) => {
                    return <PostListTemplate key={index} post={post} />
                })}
            </div>

        </div>
    )
}
export default SingleCategoryPage